/* eslint-disable max-len */
/* tslint:disable */
// TOTVS TypeScript translation resource
// Reference date : 20231003
export const generalPt = {
  str0001: 'Portal de Vendas (Linha Protheus)',
  str0002: 'Carregar mais resultados',
  str0003: 'Minhas Notificações',
  str0004: 'Minhas Vendas',
  str0005: 'Meus Orçamentos',
  str0006: 'Meus Pedidos',
  str0007: 'Meus Clientes',
  str0008: 'Vendas',
  str0009: 'Orçamentos',
  str0010: 'Clientes',
  str0011: 'Cliente',
  str0012: 'Prospects',
  str0013: 'Prospect',
  str0014: 'Notificações',
  str0015: 'Pedidos',
  str0016: 'Pedido',
  str0017: 'Pedido de Venda',
  str0018: 'Tabela de Preço',
  str0019: 'Tipo de Operação',
  str0020: 'Produtos',
  str0021: 'Produto',
  str0022: 'Orçamento',
  str0023: 'Títulos',
  str0024: 'Cards',
  str0025: 'Gráficos',
  str0026: 'Dados',
  str0027: 'entrega',
  str0028: 'Carregando',
  str0029: 'Nenhum dado encontrado',
  str0030: 'Informe o Alias Desejado',
  str0031: 'Visualizar',
  str0032: 'Mostrar Mais',
  str0033: 'Erro ao autenticar',
  str0034: 'Fechar',
  str0035: 'Data',
  str0036: 'Cancelar Filtro',
  str0037: 'Lista',
  str0038: 'Data inválida',
  str0039: 'Aplicar Filtro',
  str0040: 'Filtro de Notificações',
  str0041: 'Tipo da Notificação',
  str0042: 'Status da Notificação',
  str0043: 'Status da Movimentação',
  str0044: 'Mostrar todas as notificações',
  str0045: 'Erro ao carregar as notificações',
  str0046: 'Erro ao atualizar as notificações',
  str0047: 'Descrição',
  str0048: 'Home',
  str0049: 'Tipo de Filtro',
  str0050: 'Data Inicial',
  str0051: 'Data Final',
  str0052: 'Hora da Pesquisa',
  str0053: 'Anual',
  str0054: 'Mensal',
  str0055: 'Indicadores de Venda',
  str0056: 'Mostrando Indicadores De',
  str0057: 'Nenhum Filtro Selecionado',
  str0058: 'Filtro de Indicadores',
  str0059: 'Aplicar Filtros',
  str0060: 'Download Indicadores',
  str0061: 'Detalhes',
  str0062: 'Filtro Avançado',
  str0063: 'Erro na validação de usuário',
  str0064: 'Novo Pedido',
  str0065: 'Novo Orçamento',
  str0066: 'Observação',
  str0067: 'O sistema sempre utilizará o primeiro e último dia dos meses selecionados',
  str0068: 'Selecione o Formato de Comparação entre os Indicadores',
  str0069: 'Infome uma data Inicial e Final para Aplicar o Filtro (dd/mm/aaaa)',
  str0070: 'A data inicial não pode ser maior do que a data Final.',
  str0071: 'A diferença entre as datas não pode ser superior a 12 meses.',
  str0072: 'A diferença entre as datas não pode ser superior a 12 anos.',
  str0073: 'Pesquise pela razão social do cliente',
  str0074: 'Razão Social',
  str0075: 'Pesquise pelo nome fantasia do cliente',
  str0076: 'Nome Fantasia',
  str0077: 'Pesquise pelo CPF/CNPJ do cliente',
  str0078: 'CPF/CNPJ',
  str0079: 'Data de inclusão',
  str0080: 'Selecione o status do cliente',
  str0081: 'Status do Cliente',
  str0082: 'dd/mm/aaaa',
  str0083: 'Status',
  str0084: 'Detalhes do Cliente',
  str0085: 'Cliente não Encontrado',
  str0086: 'Foram encontrados mais de um cliente com o mesmo código',
  str0087: 'Procure a equipe de TI',
  str0088: 'Endereço',
  str0089: 'CEP',
  str0090: 'País',
  str0091: 'Estado',
  str0092: 'Cidade',
  str0093: 'Número',
  str0094: 'Complemento',
  str0095: 'Contatos',
  str0096: 'Tipo',
  str0097: 'Telefone',
  str0098: 'Não existem contatos salvos para esse cliente',
  str0099: 'Não foi possível obter os contatos do cliente pois o mesmo não possui CPF/CNPJ vinculado',
  str0100: 'Comercial',
  str0101: 'Telefone comercial',
  str0102: 'Residencial',
  str0103: 'Fax Comercial',
  str0104: 'Fax Residencial',
  str0105: 'Celular',
  str0106: 'Não identificado',
  str0107: 'Dados cadastrais',
  str0108: 'Inscrição estadual',
  str0109: 'Inscrição municipal',
  str0110: 'Código',
  str0111: 'Limite de Crédito',
  str0112: 'Crédito utilizado',
  str0113: 'Total de Crédito',
  str0114: 'Risco de Crédito',
  str0115: 'Baseado no histórico financeiro do cliente',
  str0116: 'Inadimplência',
  str0117: 'De probabilidade de inadimplência',
  str0118: 'Conecte-se à internet para ter acesso.',
  str0119: 'Ver detalhes',
  str0120: 'Título',
  str0121: 'Quantidade de títulos em aberto',
  str0122: 'Aguarde',
  str0123: 'Confirmar',
  str0124: 'Alterar Usuário',
  str0125: 'ATENÇÃO: Caso confirme a operação, todas as sincronizações pendentes serão ignoradas?',
  str0126: 'Pesquise um pedido pelo seu Código, Cliente ou Data de Emissão',
  str0127: 'Filtro de Pedidos',
  str0128: 'Formato de Comparação',
  str0129: 'Selecione o período de Comparação',
  str0130: 'Visualizada',
  str0131: 'Pesquise pelo número do título, data de vencimento, data de emissão.',
  str0132: 'Pedido liberado para faturamento',
  str0133: 'Pedido Faturado',
  str0134: 'Cliente Efetivado',
  str0135: 'Pedido Estornado',
  str0136: 'Pedido Bloqueado por Crédito',
  str0137: 'Pedido Bloqueado por Estoque',
  str0138: 'Hora',
  str0139: 'Movimentação de Pedido',
  str0140: 'Movimentação de Cliente',
  str0141: 'Aguardando Visualização',
  str0142: 'Ativado',
  str0143: 'Desativado',
  str0144: 'Última Compra',
  str0145: 'Loja',
  str0146: 'Processando...',
  str0147: 'Título Atrasado',
  str0148: 'Sem Pendencias',
  str0149: 'Pendencias Financeiras',
  str0150: 'Visualizar Detalhes',
  str0151: 'Financeiro',
  str0152: 'Filtro de Clientes',
  str0153: 'Código do Cliente',
  str0154: 'CNPJ',
  str0155: 'CPF',
  str0156: 'Nome Completo',
  str0157: 'Nome',
  str0158: 'Cons. Final',
  str0159: 'Produtor Rural',
  str0160: 'Revendedor',
  str0161: 'Solidario',
  str0162: 'Exportacao',
  str0163: 'Tipo do cliente',
  str0164: 'Dados do Contato',
  str0165: 'E-mail',
  str0166: 'Telefones',
  str0167: 'Muito Baixo',
  str0168: 'Baixo',
  str0169: 'Médio',
  str0170: 'Alto',
  str0171: 'Muito Alto',
  str0172: 'Crédito disponível',
  str0173: 'Aberto',
  str0174: 'Atrasado',
  str0175: 'Pago',
  str0176: 'Número do título',
  str0177: 'Valor',
  str0178: 'Vencimento',
  str0179: 'Prefixo',
  str0180: 'Filial',
  str0181: 'Parcela',
  str0182: 'Emissão',
  str0183: 'Vlr. Liquidado',
  str0184: 'Saldo em Aberto',
  str0185: 'Bx. Parcial',
  str0186: 'ATENÇÃO: O TOTAL DO PEDIDO APRESENTADO COMO "Valor", REFERE-SE AO VALOR BRUTO DOS ITENS.',
  str0187: 'Código do Pedido',
  str0188: 'B. Regra',
  str0189: 'B. Verba',
  str0190: 'Encerrado',
  str0191: 'Liberado',
  str0192: 'Bloqueado por Regra',
  str0193: 'Bloqueado por Verba',
  str0194: 'Pedido não sincronizado',
  str0195: 'Algumas informações do pedido podem alterar após a sincronização. Deseja continuar a geração do PDF?',
  str0196: 'Continuar',
  str0197: 'Não sincronizado',
  str0198: 'Erro',
  str0199: 'Online',
  str0200: 'Informe a data completa.',
  str0201: 'Status do Pedido',
  str0202: 'Pesquise pelo Nome ou Código do cliente',
  str0203: 'Pesquise pelo Nome ou Código do Cliente/Prospect',
  str0204: 'Pesquise pelo Código ou Descrição do Produto',
  str0205: 'Trabalhando offline',
  str0206: 'Trabalhar offline',
  str0207: 'Voltar à meus pedidos',
  str0208: 'Editar pedido',
  str0209: 'Excluir pedido',
  str0210: 'Detalhes do pedido',
  str0211: 'Gerar PDF',
  str0212: 'Download do resumo',
  str0213: 'Pedido não encontrado',
  str0214: 'Foram encontrados mais de um cliente com o mesmo código',
  str0215: 'Vendedor',
  str0216: 'Liberação por Item',
  str0217: 'Liberação por Pedido',
  str0218: 'Por conta terceiros',
  str0219: 'Por conta remetente',
  str0220: 'Por conta destinatário',
  str0221: 'Sem frete',
  str0222: 'CIF',
  str0223: 'FOB',
  str0224: 'Não especificado',
  str0225: 'Entrega e Pagamento',
  str0226: 'Tipo de Liberação',
  str0227: 'Tipo de Frete',
  str0228: 'Transportadora',
  str0229: 'Endereço de Entrega',
  str0230: 'Condição de Pagamento',
  str0231: 'Informações do cliente',
  str0232: 'Endereço de faturamento',
  str0233: 'Total do Pedido',
  str0234: 'Subtotal',
  str0235: 'Impostos',
  str0236: 'Frete',
  str0237: 'Seguro',
  str0238: 'Despesas',
  str0239: 'Descontos',
  str0240: 'Desconto',
  str0241: 'Não',
  str0242: 'Item',
  str0243: 'Itens',
  str0244: 'Quantidade',
  str0245: 'Preço Unitário',
  str0246: 'Total',
  str0247: 'Informações Gerais',
  str0248: 'Pesquise pelo Código ou Descrição do Produto',
  str0249: 'Iniciar Pedido',
  str0250: 'Iniciar orçamento',
  str0251: 'Cancelar',
  str0252: 'Itens do Pedido',
  str0253: 'Itens do Orçamento',
  str0254: 'Dados Gerais',
  str0255: 'Ver detalhes do cliente',
  str0256: 'Subtotal do pedido',
  str0257: 'Quantidade de itens',
  str0258: 'Cancelar pedido',
  str0259: 'Cancelar alteração',
  str0260: 'Tem certeza que deseja cancelar a alteração do pedido?',
  str0261: 'Tem certeza que deseja cancelar o novo pedido?',
  str0262: 'Próximo passo',
  str0263: 'Qtd. Itens',
  str0264: 'Visibilidade de Itens',
  str0265: 'Selecione uma tabela de preço para visualizar os itens e seus detalhes.',
  str0266: 'Comentários',
  str0267: 'Limite de crédito disponível',
  str0268: 'Desconto acumulativo dos itens',
  str0269: 'Selecione uma tabela de preço',
  str0270: 'Todos os itens da tabela',
  str0271: 'Apenas itens do pedido',
  str0272: 'Selecione o modo de pagamento',
  str0273: 'Selecione a transportadora',
  str0274: 'Selecione o tipo de frete',
  str0275: 'Informe o valor do seguro',
  str0276: 'Informe o valor das despesas',
  str0277: 'Informações gerais do pedido',
  str0278: 'Informações de entrega',
  str0279: 'Informe o valor do frete',
  str0280: 'Selecione o tipo de liberação',
  str0281: 'Tipo do Pedido',
  str0282: 'Moeda',
  str0283: 'Parcial',
  str0284: 'Em carteira',
  str0285: 'Percentual',
  str0286: 'Valor em moeda',
  str0287: 'Desconto em produto',
  str0288: 'Preço de lista',
  str0289: 'Preço unitário informado',
  str0290: 'Preço total do produto',
  str0291: 'Desconto em',
  str0292: 'Desconto percentual',
  str0293: 'Apenas números',
  str0294: 'Valor do desconto',
  str0295: 'Valor com desconto',
  str0296: 'Margem com desconto',
  str0297: 'Cancelar desconto',
  str0298: 'Aplicar desconto',
  str0299: 'Não foi possível gerar o PDF. Tente novamente.',
  str0300: 'Pesquise um produto pelo seu Código ou Descrição',
  str0301: 'Comentários do pedido',
  str0302: 'O cliente não poderá ver os comentários incluidos.',
  str0303: 'Valor Total',
  str0304: 'Adicionar Desconto',
  str0305: 'Pesquisar Produtos',
  str0306: 'Produtos selecionados',
  str0307: 'Mostrando',
  str0308: 'de',
  str0309: 'encontrado',
  str0310: 'encontrados',
  str0311: 'Adicione comentários do pedido. Exemplo: Entregar no periodo da tarde, solicitar assinatura da gerente de operação...',
  str0312: 'Tabela de Preços inativa',
  str0313: 'Tabela de Preço fora de vigência',
  str0314: 'Preços do produto fora de vigência',
  str0315: 'Produto Selecionado',
  str0316: 'Nenhum Produto Selecionado',
  str0317: 'Resumo do Pedido',
  str0318: 'Erro ao retornar Condição de Pagamento',
  str0319: 'Pendente de sincronização',
  str0320: 'Prc. Unit.',
  str0321: 'Prc. Lista',
  str0322: 'Prc. Total',
  str0323: 'Qtd. Entr.',
  str0324: 'O Valor dos impostos será calculado somente após o sincronismo do Pedido.',
  str0325: 'Condição de Pagamento invalida para esta tabela de preços',
  str0326: 'Adicionar',
  str0327: '+ Informações',
  str0328: 'Selecione o Tipo de Operação',
  str0329: 'Informe um cliente ou prospect para iniciar o Orçamento',
  str0330: 'Informe um cliente para iniciar o Pedido',
  str0331: 'Alterar Pedido',
  str0332: 'Falha ao incluir Pedido de Venda',
  str0333: 'Pedido enviado para sincronização.',
  str0334: 'Erro no envio do JSON',
  str0335: 'Erro no envio do Pedido para sincronização',
  str0336: 'Pedido Efetivado',
  str0337: 'Falha ao integrar Pedido',
  str0338: 'Mostrar detalhes do pedido',
  str0339: 'Falha ao Excluir Pedido de Venda',
  str0340: 'Confirmar Exclusão',
  str0341: 'Deseja realmente excluir este Pedido?',
  str0342: 'Status Inválido',
  str0343: 'Não é permitido excluir um Pedido de Venda com Status Liberado, Encerrado ou Não Sincronizado.',
  str0344: 'Pedido incluído',
  str0345: 'Pedido alterado',
  str0346: 'Pedido excluído',
  str0347: 'Sair',
  str0348: 'Tem certeza que deseja sair?',
  str0349: 'Podem existir pedidos pendentes de sincronização, ao sair eles serão cancelados.',
  str0350: 'O valor total do pedido pode variar de acordo com sua conexão de internet, pois os impostos são calculados apenas se estiver online.',
  str0351: 'Falha ao calcular impostos',
  str0352: 'Tente novamente mais tarde.',
  str0353: 'Calculando totais',
  str0354: 'Falha ao salvar log de acesso',
  str0355: 'Sua sessão expirou',
  str0356: 'Será necessário efetuar login novamente para sincronizar suas alterações.\nDeseja realizar o login agora? Caso contrário o sistema ficará em modo offline.',
  str0357: 'Falha ao retornar os Tipos de Operação',
  str0358: 'Voltar para Meus Orçamentos',
  str0359: 'Detalhes do Orçamento',
  str0360: 'Falha ao carregar orçamento',
  str0361: 'Falha ao carregar cliente',
  str0362: 'Mais informações',
  str0363: 'Informações do prospect',
  str0364: 'Código do Prospect',
  str0365: 'Falha ao carregar prospect',
  str0366: 'Pesquise um Orçamento pelo seu Código, Código do Cliente/Prospect ou Data de Emissão',
  str0367: 'Selecione o status do pedido',
  str0368: 'Em Aberto',
  str0369: 'Baixado',
  str0370: 'Cancelado',
  str0371: 'Não Orçado',
  str0372: 'Bloqueado',
  str0373: 'DT Emissão',
  str0374: 'Falha ao retornar pesquisa de produtos.',
  str0375: 'Status do Orçamento',
  str0376: 'Filtro de Orçamentos',
  str0377: 'Cliente ou Prospect',
  str0378: 'Código do Orçamento',
  str0379: 'Pesquise um cliente pelo seu Código, Nome ou CGC',
  str0380: 'Pesquise um prospect pelo seu Código, Nome ou CGC',
  str0381: 'Orçamento incluído',
  str0382: 'Orçamento alterado',
  str0383: 'Orçamento Excluído',
  str0384: 'Pesquise pelo código, nome fantasia ou CNPJ/CPF do cliente.',
  str0385: 'Selecione o tipo da notificação',
  str0386: 'Selecione o status da notificação',
  str0387: 'Selecione o status da movimentação',
  str0388: 'Selecione o status do orçamento',
  str0389: 'Pesquise uma notificação pelo seu Título ou Descrição',
  str0390: 'Erro ao carregar Orçamentos',
  str0391: 'Erro ao Retornar as Notificações',
  str0392: 'Erro ao Retornar os Clientes',
  str0393: 'Erro ao Retornar os Pedidos ',
  str0394: 'Erro ao Retornar os Produtos',
  str0395: 'Erro ao Retornar os Titulos',
  str0396: 'Erro ao retornar Vendedores',
  str0397: 'Falha ao Atualizar Preço Unitário',
  str0398: 'Falha ao carregar item da Tabela de Preço',
  str0399: 'Não foi possivel localizar o produto informado',
  str0400: 'Carregando dados de entrega...',
  str0401: 'Carregando dados do pedido...',
  str0402: 'Carregando Cards e Gráficos',
  str0403: 'Erro ao consultar inadimplencia',
  str0404: 'Selecione o status do Orçamento',
  str0405: 'Editar orçamento',
  str0406: 'Excluir orçamento',
  str0407: 'Novo Orçamento',
  str0408: 'Iniciar orçamento',
  str0409: 'Itens do Orçamento',
  str0410: 'Salvar',
  str0411: 'Subtotal do orçamento',
  str0412: 'Total do Orçamento',
  str0413: 'Cancelar orçamento',
  str0414: 'Tem certeza que deseja cancelar a alteração do orçamento?',
  str0415: 'Tem certeza que deseja cancelar o novo orçamento?',
  str0416: 'Apenas itens do orçamento',
  str0417: 'Informações gerais do orçamento',
  str0418: 'Tipo do orçamento',
  str0419: 'Resumo do Orçamento',
  str0420: 'Alterar Orçamento',
  str0421: 'Falha ao incluir orçamento.',
  str0422: 'Orçamento enviado para sincronização.',
  str0423: 'Orçamento Efetivado',
  str0424: 'Falha ao integrar Orçamento',
  str0425: 'Mostrar detalhes do orçamento',
  str0426: 'Deseja realmente excluir este Orçamento?',
  str0427: 'Não é permitido excluir um orçamento com o status de Baixado, Não Sincronizado ou que possua uma Proposta Comercial vinculada.',
  str0428: 'Carregando dados do orçamento...',
  str0429: 'Orçamento',
  str0430: 'Detalhes do Orçamento',
  str0431: 'Falha ao carregar orçamento',
  str0432: 'Meus Orçamentos',
  str0433: 'Orçamentos',
  str0434: 'Pesquise um Orçamento pelo seu Código, Código do Cliente/Prospect ou Data de Emissão',
  str0435: 'Carregando Orçamentos',
  str0436: 'Erro ao carregar Orçamentos',
  str0437: 'Em Aberto',
  str0438: 'Baixado',
  str0439: 'Cancelado',
  str0440: 'Não Orçado',
  str0441: 'Bloqueado',
  str0442: 'Número',
  str0443: 'DT Emissão',
  str0444: 'Falha ao retornar pesquisa de produtos.',
  str0445: 'Status do Orçamento',
  str0446: 'Filtro de Orçamentos',
  str0447: 'Cliente ou Prospect',
  str0448: 'Código do Orçamento',
  str0449: 'Pesquise um prospect pelo seu Código, Nome ou CGC',
  str0450: 'Orçamento incluído',
  str0451: 'Orçamento alterado',
  str0452: 'Orçamento excluído',
  str0453: 'Movimentação de Orçamento',
  str0454: 'Pesquise um cliente pelo seu Código, Nome ou CGC',
  str0455: 'Voltar para Meus Orçamentos',
  str0456: 'Mostrar detalhes do orçamento',
  str0457: 'Orçamento não sincronizado',
  str0458: 'Algumas informações do orçanento podem alterar após a sincronização. Deseja continuar a geração do PDF?',
  str0459: 'Orçamento não pode ser excluido, possui uma proposta comercial vinculada.',
  str0460: 'Campos personalizados',
  str0461: 'Falha ao excluir orçamento',
  str0462: 'Erro ao Retornar os orçamentos',
  str0463: 'Valor inválido',
  str0464: 'Salvar pedido',
  str0465: 'O valor total do orçamento pode variar de acordo com sua conexão de internet, pois os impostos são calculados apenas se estiver online.',
  str0466: 'Erro no envio do orçamento para sincronização',
  str0467: 'Dados financeiros',
  str0468: 'Sincronizando',
  str0469: 'Faturamento (Valor)',
  str0470: 'Não Aplica',
  str0471: 'Presencial',
  str0472: 'Operação não presencial, pela Internet',
  str0473: 'Não presencial, Teleatendimento',
  str0474: 'Presencial, Fora do Estab.',
  str0475: 'Não Presencial, Outros',
  str0476: 'Código do Intermediador',
  str0477: 'Presença do Comprador',
  str0478: 'Intermediador Financeiro',
  str0479: 'Falha ao obter Intermediadores Financeiros',
  str0480: 'Selecione o Intermediador Financeiro',
  str0481: 'Selecione o Indicador de Presença',
  str0482: 'Sincronismo interrompido, clique no "X" do menu acima para reiniciar',
  str0483: 'Erro no sincronismo.',
  str0484: 'Não foi possivel realizar a carga inicial dos dados. Tente novamente clicando aqui.',
  str0485: 'Voltar',
  str0486: 'Calculando...',
  str0487: 'Insira seu usuário',
  str0488: 'Insira sua senha',
  str0489: 'Falha ao obter Lista de campos',
  str0490: 'Este contato não possui telefones.',
  str0491: 'Este cliente não possui limite de crédito informado.',
  str0492: 'Este campo não aceita caracteres especiais.',
  str0493: 'Pedido incluído com sucesso.',
  str0494: 'Pedido alterado com sucesso.',
  str0495: 'Falha ao alterar Pedido de Venda.',
  str0496: 'Pedido excluído com sucesso.',
  str0497: 'Erro ao calcular total: ',
  str0498: 'contém',
  str0499: 'Excluindo pedido...',
  str0500: 'Não foram encontrados os schemas necessários para utilização do TGV. Verifique se a função SETUPTGV foi executada conforme documentação: <a href="https://tdn.totvs.com/pages/releaseview.action?pageId=579468339#TOTVSGest%C3%A3odeVendas:GuiadeReferencia-CONFIG_PILOTO" target="_blank"> TGV - Guia de Referência </a> ',
  str0501: 'Quantidade de Produtos',
  str0502: 'Qtd. Produtos',
  str0503: 'Acesso Negado',
  str0504: 'Usuario não possui vinculo com um Vendedor!',
  str0505: 'Usuario não possui accesso a dados sensiveis ou pessoais',
  str0506: 'Erro no Schema',
  str0507: 'Falha ao retornar Pedido de Venda',
  str0508: 'Falha ao retornar os schemas. Verifique as tabelas A1V e A1W.',
  str0509: 'Carregando itens do Pedido...',
  str0510: 'Normal',
  str0511: 'Complemento de Preço/Quantidade',
  str0512: 'Complemento de ICMS',
  str0513: 'Complemento de IPI',
  str0514: 'Devolução de Compras',
  str0515: 'Utiliza Fornecedor',
  str0516: 'Falha ao obter item do Pedido',
  str0517: 'Falha ao retornar as opções para o Tipo de Pedido',
  str0518: 'Falha ao retornar país',
  str0519: 'Digite o código do grupo ou realize sua busca clicando na lupa',
  str0520: 'Digite o código da filial ou realize sua busca clicando na lupa',
  str0521: 'Grupo',
  str0522: 'Trocar de Filial',
  str0523: 'ATENÇÃO: A filial selecionada é a mesma que a atual. Selecione uma filial diferente.',
  str0524: 'Entrar',
  str0525: 'ATENÇÃO',
  str0526: 'Sua sessão expirou. Para prosseguir, realize o login novamente.',
  str0527: 'Consultando títulos',
  str0528: 'Portal de Vendas',
  str0529: 'Carregando informações do Cliente...',
  str0530: 'Falha ao consultar vendedor',
  str0531: 'Falha ao obter informações financeiras',
  str0532: 'Você pode atualizar a sua versão baixando o pacote da expedição continua clicando <a href="https://tdn.totvs.com/pages/releaseview.action?pageId=521997859" target="_blank">AQUI</a>.',
  str0533: 'Versão do PGV desatualizada',
  str0534: 'Nova versão disponível. Deseja recarregar a página?',
  str0535: 'Falha ao tentar filtrar Orçamentos de Vendas',
  str0536: 'Mensagem',
  str0537: 'Consultando nome do Prospect',
  str0538: 'Consultando nome do Cliente',
  str0539: 'Falha ao consultar nome do Prospect',
  str0540: 'Falha ao consultar nome do Cliente',
  str0541: 'Não foi possivel registrar o vendedor',
  str0542: 'Falha ao carregar itens do orçamento',
  str0543: 'Orçamento excluído com sucesso.',
  str0544: 'Excluindo orçamento...',
  str0545: 'Sim',
  str0546: 'Tipo do prospect',
  str0547: 'Orçamento incluído com sucesso.',
  str0548: 'Orçamento alterado com sucesso.',
  str0549: 'Não é permitido alterar um orçamento com o status de Baixado, Cancelado, Não Sincronizado ou que possua uma Proposta Comercial vinculada.',
  str0550: 'Falha ao alterar orçamento.',
  str0551: 'Mensagem da nota',
  str0552: 'Adicione comentários que sejam importantes sobre este pedido de venda.',
  str0553: 'A mensagem definida será impressa na nota fiscal.',
  str0554: 'Adicione uma mensagem a ser utilizada na nota fiscal. Exemplo: Entregar no período da tarde.',
  str0555: 'Sincronizar dados',
  str0556: 'Sincronismo concluído',
  str0557: 'Sincronizando dados, por favor aguarde...',
  str0558: 'Falha ao retornar permissões de acesso do usuário',
  str0559: 'Você não tem acesso à essa página',
  str0560: 'Contate o administrador do sistema',
  str0561: 'Voltar para o início',
  str0562: 'Filtrar por tabela de preços',
  str0563: 'Falha ao consultar parâmetro MV_PGVCSLD',
  str0564: 'Ops, algo deu errado',
  str0565: 'Consultar Estoque',
  str0566: 'Armazém',
  str0567: 'Saldo Atual',
  str0568: 'Qtd. Pedido Vendas',
  str0569: 'Qtd. Empenhada',
  str0570: 'Qtd. Prevista entrada',
  str0571: 'Falha ao consultar Saldo do Produto',
  str0572: 'Demais informações',
  str0573: 'Pedido do cliente',
  str0574: 'Número do pedido do cliente',
  str0575: 'Falha ao consultar Schema',
  str0576: 'Minhas Configurações Off-line',
  str0577: 'Configurações Off-line',
  str0578: 'Editar',
  str0579: 'Pesquise um Schema pelo seu Código ou Descrição',
  str0580: 'Falha ao tentar filtrar Schemas',
  str0581: 'Voltar para minhas configurações',
  str0582: 'Editar minhas configurações',
  str0583: 'Avançar',
  str0584: 'Editar configurações dos',
  str0585: 'Filtro rápido',
  str0586: 'Selecionar registros',
  str0587: 'Nenhum item foi adicionado ao Pedido de Venda',
  str0588: 'Nenhum item foi adicionado ao Orçamento de Venda',
  str0589: 'Clientes que compraram em:',
  str0590: 'Habilitado',
  str0591: 'Desabilitado',
  str0592: 'Igual',
  str0593: 'Contém a expressão',
  str0594: 'Tipo de busca',
  str0595: 'Selecione o tipo de busca desejado',
  str0596: 'Últimos três meses',
  str0597: 'Selecionar apenas os produtos mais vendidos pelo vendedor nos últimos três meses.',
  str0598: 'Saldo em estoque',
  str0599: 'Informe o código dos produtos separando por vírgula',
  str0600: 'Informe a descrição dos produtos separando por vírgula',
  str0601: 'Informe o tipo dos produtos separando por vírgula Ex: PA, MP',
  str0602: 'Informe o código da tabela de preços separando por vírgula',
  str0603: 'Selecionar apenas os produtos que tenham saldo em estoque.',
  str0604: 'Descrição do Produto 1, Descrição do Produto 2',
  str0605: '000001,000002,000003,000004',
  str0606: 'Tabela 1, Tabela 2',
  str0607: 'Último mês',
  str0608: 'Selecionar apenas Clientes que compraram no último mês.',
  str0609: 'Selecionar apenas Clientes que compraram nos últimos três meses.',
  str0610: 'Novos Clientes',
  str0611: 'Selecionar Clientes cadastrados no último mês.',
  str0612: 'Não compraram no último mês',
  str0613: 'Selecionar Clientes que não compraram no último mês.',
  str0614: 'Informe o código dos Clientes separando por virgula.',
  str0615: 'Nome Fantasia / Razão Social',
  str0616: 'Informe o Nome Fantasia ou Razão Social separando por virgula.',
  str0617: 'João da Silva,Maria Lima,José de Souza',
  str0618: 'Informe o CPF ou CNPJ dos Clientes separando por virgula.',
  str0619: '00.000.000/0000-00',
  str0620: 'PA, MP',
  str0621: 'Vazio',
  str0622: 'Esta página não esta disponível para utilização off-line',
  str0623: 'Off-line',
  str0624: 'selecionados',
  str0625: 'Filtrar registros por: ',
  str0626: 'Não há dados selecionados',
  str0627: 'Falha ao consultar Limite de Crédito, por favor atualize o servidor backend com último pacote de expedição contínua do Faturamento.',
  str0628: 'Marcar/Desmarcar',
  str0629: 'Selecionar todos',
  str0630: 'Núm. Externo',
  str0631: 'Código',
  str0632: 'Ativo',
  str0633: 'Armazém',
  str0634: 'Unidade de medida',
  str0635: 'Filtro registrado com sucesso.',
  str0636: 'Filtro excluido com sucesso.',
  str0637: 'Falha ao registrar filtro.',
  str0638: 'Falha ao excluir filtro.',
  str0639: 'Deseja realizar a carga de dados ?',
  str0640: 'Realizar carga dos dados',
  str0641: 'Ops... O limite de ',
  str0642: 'items foi atingido',
  str0643: 'Item já faturado total ou parcialmente, para excluí-lo é preciso excluir a Nota Fiscal correspondente.',
  str0644: 'Em breve esta página estará disponível',
  str0645: 'Estamos sincronizando os dados, por favor aguarde...',
  str0646: 'Alias não encontrado',
  str0647: 'Origem',
  str0648: 'Usuário não autenticado - Verifique se o usuario se encontra bloqueado ou se o mesmo foi cadastrado no Protheus.',
  str0649: 'Seu usuário não possuí vínculo com um vendedor. Para ajustar isso você deve fazer a atribuição conforme a documentação <a href="https://tdn.totvs.com/pages/viewpage.action?pageId=649301318"  target="_blank"> clicando aqui </a>',
  str0650: 'Ops! Não foi possível acessar seu usuário.',
  str0651: 'Falha ao consultar transportadoras',
  str0652: 'Dt.Cadastro',
  str0653: 'Limite de Conexões Excedidos',
  str0654: 'Página não encontrada.',
  str0655: 'Desculpe, a página que você está procurando não existe.',
  str0656: 'Selecionar apenas Prospects que possuem orçamentos em aberto no último mês.',
  str0657: 'Selecionar apenas Prospects que possuem orçamentos em aberto nos últimos três meses.',
  str0658: 'Selecionar Prospects cadastrados no último mês.',
  str0659: 'Selecionar Prospects sem orçamentos de vendas nos últimos três meses.',
  str0660: 'Informe o código dos Prospects separando por virgula.',
  str0661: 'Informe o CPF ou CNPJ dos Prospects separando por virgula.',
  str0662: 'Novos Prospects',
  str0663: 'Não compraram nos últimos três mês',
  str0664: 'Não foi possivel atualizar os dados financeiros do cliente',
  str0665: 'Novo Cliente',
  str0666: 'Iniciar Cadastro',
  str0667: 'Selecione um cliente para iniciar o cadastro',
  str0668: 'Pessoa tipo',
  str0669: 'Adicionar nova loja?',
  str0670: 'Pessoa Física',
  str0671: 'Pessoa Jurídica',
  str0672: 'Falha ao consultar Tipo de pessoa do Cliente',
  str0673: 'Selecione as preferencias abaixo para cadastro de um novo cliente.',
  str0674: 'Não foi possivel obter o Tipo de operação padrão',
  str0675: 'Não foi possivel obter os dados do parâmetro',
  str0676: 'Ops, a sua empresa e filial não foi encontrada no TOTVS Mingle',
  str0677: 'Empresa/Filial não encontrada',
  str0678: 'Entre em contato com o suporte do TOTVS Mingle para corrigir o cadastro do Alias',
  str0679: 'Documento inválido',
  str0680: 'Digite a razão social ou nome completo',
  str0681: 'Digite o nome ou nome fantasia',
  str0682: 'Digite a inscrição estadual',
  str0683: 'Digite a inscrição municipal',
  str0684: 'Selecione o tipo',
  str0685: 'Tipo',
  str0686: 'Carregando opções...',
  str0687: 'Digite o código',
  str0688: 'Sugerimos um código de identificação mas você pode alterá-lo.',
  str0689: 'Digite o complemento do endereço',
  str0690: 'Tipo de Pessoa',
  str0691: 'Selecione o tipo de pessoa',
  str0692: 'Informe apenas números',
  str0693: 'Selecione o estado',
  str0694: 'Selecione a cidade/municipio',
  str0695: 'Digite o endereço',
  str0696: 'Bairro',
  str0697: 'Digite o bairro',
  str0698: 'Nome do contato',
  str0699: 'Digite o nome do contato',
  str0700: 'Digite o email do contato',
  str0701: 'Informe um e-mail válido',
  str0702: 'Apenas números',
  str0703: 'Documento',
  str0704: 'Cadastro de Clientes',
  str0705: 'Identificação',
  str0706: 'Versão Core',
  str0707: 'Campos Customizados',
  str0708: 'Não há dados a serem apresentados',
  str0709: 'Excluir',
  str0710: 'Editar Cliente',
  str0711: 'Cliente incluído com sucesso.',
  str0712: 'Cliente alterado com sucesso.',
  str0713: 'Cliente excluído com sucesso.',
  str0714: 'Falha ao incluir Cliente.',
  str0715: 'Falha ao alterar Cliente.',
  str0716: 'Falha ao excluir Cliente.',
  str0717: 'Deseja realmente excluir esse Cliente ?',
  str0718: 'A chave security está desabilitada.',
  str0719: 'A versão da lib não está compatível com o PGV. Atualize a lib do Protheus.',
  str0720: 'Atenção código e loja já cadastrados!',
  str0721: 'Não foi possível verificar a chave security. Atualize a versão do backend, realize um logout e um login.',
  str0722: 'Meus Prospects',
  str0723: 'Pesquise pelo código, nome fantasia ou CNPJ/CPF do Prospect',
  str0724: 'Classificado',
  str0725: 'Desenvolvimento',
  str0726: 'Gerente',
  str0727: 'StandBy',
  str0728: 'Desqualificado',
  str0729: 'Falha ao carregar Prospects',
  str0730: 'Status Atual',
  str0731: 'Ops... a condição de pagamento selecionada automaticamente',
  str0732: 'não pode ser utilizada para esta experiência de venda. Contate o especialista de TI da sua empresa.',
  str0733: 'Ops... a tabela de preço selecionada automaticamente',
  str0734: 'Cliente incluído',
  str0735: 'Cliente alterado',
  str0736: 'Cliente excluído',
  str0737: 'Falha ao integrar Cliente',
  str0738: 'Pesquise pela razão social do prospect',
  str0739: 'Pesquise pelo nome fantasia do prospect',
  str0740: 'Pesquise pelo CPF/CNPJ do prospect',
  str0741: 'Selecione o status do prospect',
  str0742: 'Selecione a classificação do prospect',
  str0743: 'Status do Prospect',
  str0744: 'Classificação do Prospect',
  str0745: 'Filtro de Prospects',
  str0746: 'Digite a cidade/município',
  str0747: 'Falha ao carregar o inicializador dos campos do formulário',
  str0748: 'Novo Prospect',
  str0749: 'Editar Prospect',
  str0750: 'Cadastro de Prospects',
  str0751: 'Deseja realmente excluir esse Prospect ?',
  str0752: 'Prospect incluído com sucesso',
  str0753: 'Prospect alterado com sucesso',
  str0754: 'Prospect excluído com sucesso',
  str0755: 'Falha ao excluir Prospect',
  str0756: 'Falha ao integrar Prospect',
  str0757: 'Atualização de Link de Acesso',
  str0758: 'Para uma melhor experiência no Portal Gestão de Vendas, estamos atualizando o link de acesso para uma conta Totvs na AWS. Sendo assim, precisamos que passe a acessar até 07/12, pelo novo link. Caso estiver acessando de um tablet ou celular, será necessário criar um novo atalho em sua area de trabalho.',
  str0759: 'Detalhes do Prospect',
  str0760: 'DDD',
  str0761: 'UF',
  str0762: 'CLIQUE AQUI',
  str0763: 'Selecione as preferencias abaixo para cadastro de um novo Prospect.',
  str0764: 'Meus Contatos',
  str0765: 'Pesquise pelo código, nome ou CPF/CNPJ',
  str0766: 'Deseja realmente excluir esse Contato?',
  str0767: 'Contato excluído com sucesso.',
  str0768: 'Falha ao carregar Contatos',
  str0769: 'Falha ao excluir Contato.',
  str0770: 'Cadastro de Contatos',
  str0771: 'DDI',
  str0772: 'Editar Contato',
  str0773: 'Novo Contato',
  str0774: 'Contato alterado com sucesso.',
  str0775: 'Contato incluído com sucesso.',
  str0776: 'Falha ao integrar Contato',
  str0777: 'Deseja realmente excluir esse Contato ?',
  str0778: 'Contato excluído com sucesso.',
  str0779: 'Falha ao excluir Contato.',
  str0780: 'Comercial',
  str0781: 'Residencial',
  str0782: 'Fax Comercial',
  str0783: 'Fax Residencial',
  str0784: 'Celular',
  str0785: 'Detalhes do Contato',
  str0786: 'Dados de Endereço e Telefone',
  str0787: 'Total de Pedidos de Vendas',
  str0788: 'Quantidade de pedidos',
  str0789: 'Última atualização em',
  str0790: 'Total de Pedidos de Vendas em Abertos',
  str0791: 'Total de Pedidos de Vendas Bloqueados',
  str0792: 'Total de Pedidos de Vendas Encerrados',
  str0793: 'Minhas Metas de Vendas',
  str0794: 'Minhas Metas',
  str0795: 'Metas de Vendas',
  str0796: 'Quantidade Liberada',
  str0797: 'Nota Fiscal',
  str0798: 'Serie',
  str0799: 'Codigo do Cliente',
  str0800: 'Erro ao Buscar Lista de pedidos',
  str0801: 'Vincular Contatos',
  str0802: 'Nenhum Pedido Encontrado:',
  str0803: 'Erro ao buscar a meta de vendas do vendedor:',
  str0804: 'Valor Bruto:',
  str0805: 'Valor Líquido:',
  str0806: 'Valor Devolvido:',
  str0807: 'Meta Mensal',
  str0808: 'Dados registrados com sucesso !',
  str0809: 'Falha ao registrar dados.',
  str0810: 'Data de Entrega',
  str0811: 'Erro ao buscar os dados do gráfico de vendas dos últimos 7 dias.',
  str0812: 'Produtos mais Vendidos - Mensal',
  str0813: 'Faturamento dos últimos 7 dias',
  str0814: 'Vl. Bruto ',
  str0815: 'Vl. Liquido ',
  str0816: 'Vl. Devolvido ',
  str0817: 'Qtd de Vendas',
  str0818: 'Valor Contábil',
  str0819: 'Valor da Mercadoria',
  str0820: 'Total de Impostos Embutidos',
  str0821: 'Total de Impostos sem Incidência',
  str0822: 'Valor Total de Impostos',
  str0823: 'Base Duplicada',
  str0824: 'Despesas Acessórias',
  str0825: 'Imposto',
  str0826: 'Base de Cálculo',
  str0827: 'Alíquota',
  str0828: 'Código do Produto',
  str0829: 'Valor ST',
  str0830: 'Valor CSLL',
  str0831: 'Valor Unitário',
  str0832: 'Alíquota PIS',
  str0833: 'Alíquota IPI',
  str0834: 'Valor PIS',
  str0835: 'Valor PIS Apuração',
  str0836: 'Valor PIS ST',
  str0837: 'Alíquota COFINS',
  str0838: 'Valor COFINS',
  str0839: 'Valor COFINS Apuração',
  str0840: 'Alíquota ST',
  str0841: 'Alíquota CSLL',
  str0842: 'Valor ICMS',
  str0843: 'Valor IPI',
  str0844: 'TES',
  str0845: 'Planilha Financeira',
  str0846: 'Totais',
  str0847: 'Notas Fiscais do Pedido: ',
  str0848: 'Não foi possível carregar as notas fiscais',
  str0849: 'Notas Fiscais',
  str0850: 'Não existem notas fiscais vínculadas a esse Pedido de Vendas',
  str0851: 'Nota Fiscal',
  str0852: 'Tipo da Nota Fiscal',
  str0853: 'Chave da Nota Fiscal',
  str0854: 'Serie da Nota',
  str0855: 'Nota Fiscal Chave Eletrônica',
  str0856: 'Dados para acesso da NF',
  str0857: 'Não há URL cadastrada para esse município.',
  str0858: 'Não foi possível consultar a nota fiscal',
  str0859: 'Acessar Nota Fiscal',
  str0860: 'Chave de Acesso',
  str0861: 'Caro cliente, você será redirecionado ao site da prefeitura. Para fazer o download da Nota Fiscal de Serviço será necessário preencher as informações solicitadas.',
  str0862: 'Personalizar PDF',
  str0863: 'Url da Imagem',
  str0864: 'Selecione qual o tipo de Personalização',
  str0865: 'Tipo de PDF',
  str0866: 'Novo Pdf Customizado',
  str0867: 'Minhas Configurações de PDF',
  str0868: 'Editar PDF',
  str0869: 'Novo PDF',
  str0870: 'PDF alterado com sucesso',
  str0871: 'PDF incluído com sucesso',
  str0872: 'Falha ao incluir PDF',
  str0873: 'Seções',
  str0874: 'Campos',
  str0875: 'Código da Seção',
  str0876: 'Título da Seção',
  str0877: 'Descrição da Seção',
  str0878: 'Selecione a Seção',
  str0879: 'Selecione os Campos',
  str0880: 'Cabeçalho',
  str0881: 'Propriedade',
  str0882: 'Formato',
  str0883: 'Decimal',
  str0884: 'Separador de Milhar',
  str0885: 'Mover para cima',
  str0886: 'Mover para baixo',
  str0887: 'Incluir campo',
  str0888: 'Alterar campo',
  str0889: 'Caracter',
  str0890: 'Numérico',
  str0891: 'Lógico',
  str0892: 'Confirma Exclusão da seção',
  str0893: 'Deseja realmente excluir esta seção? Ao excluir os campos também serão excluídos.',
  str0894: 'Confirmar',
  str0895: 'Confirma Exclusão do campo',
  str0896: 'Deseja realmente excluir deste campo?',
  str0897: 'Informe todos os dados obrigatórios antes de confirmar a inclusão.',
  str0898: 'Há campos obrigatórios nas configurações do PDF que não foram preenchidos.',
  str0899: 'Há campos obrigatórios em alguma das seções da configuração do PDF que não foram preenchidos.',
  str0900: 'Há alguma das seção da configuração do PDF que não tem campos informados.',
  str0901: 'Nenhuma seção da configuração do PDF foi informada. Isso é necessário para a gravação da configuração no banco de dados.',
  str0902: 'Falha ao carregar as Configurações de PDF',
  str0903: 'Confirma Exclusão da Configuração de PDF',
  str0904: 'Deseja realmente excluir esta Configuração de PDF?',
  str0905: 'Pesquise pelo código, título ou descrição da configuração de PDF.',
  str0906: 'Visualizar PDF',
  str0907: 'Seleção de PDF',
  str0908: 'Escolha o modelo de PDF',
  str0909: 'Modelo Padrão',
  str0910: 'Não é possível adicionar mais que uma seção de Itens',
  str0911: 'Personalizado',
  str0912: 'Não é possível incluir mais que 7 campos em Seções do tipo Itens',
  str0913: 'Meus Produtos',
  str0914: 'Foto do Produto',
  str0915: 'Efetivar',
  str0916: 'Efetivação do Orçamento',
  str0917: 'Deseja prosseguir com a efetivação do orçamento',
  str0918: 'Cancelar',
  str0919: 'Cancelamento do Orçamento',
  str0920: 'Deseja prosseguir com o cancelamento do orçamento',
  str0921: 'Erro ao efetivar o orçamento.',
  str0922: 'Erro ao cancelar o orçamento.',
  str0923: 'Minhas Comissões',
  str0924: 'Comissões',
  str0925: 'A url da imagem é inválida ou está bloqueada por CORS. Contate sua área de TI ou informe uma url válida.',
  str0926: 'Consultar',
  str0927: 'Exportar xlsx',
  str0928: 'Não foi possível carregar os dados do relatório',
  str0929: 'Verifique se todos os campos foram preenchidos corretamente antes de realizar a consulta',
  str0930: 'A data do campo "Até a data ?" deve ser posterior à data do campo "Da Data ?" e o intervalo entre as duas não pode ultrapassar 1 ano.',
  str0931: 'Voltar à minhas comissões',
  str0932: 'Nenhum registro encontrado com os valores informados',
  str0933: 'Logotipo Padrão',
  str0934: 'Logotipo do PDF Padrão atualizado com sucesso',
  str0935: 'Atualize a versão do backend do PGV, conforme o link abaixo, depois realize um logout e um login.',
  str0936: 'Contato vinculado com sucesso',
  str0937: 'Falha ao incluir/alterar contato',
  str0938: 'Em Aprovação',
  str0939: 'Rejeitado',
  str0940: 'Controle de Crédito por'
};
